import type { UIMatch } from '@remix-run/react'

/** Loader data shape we care about (optional on any route). */
export type UspData = { uspBlock?: boolean }

/** Handle shape supported by routes. */
export type UspHandle = {
  /** Static: always show on this route. */
  uspBlock?: boolean
  /** Dynamic: compute from this route's loader data. */
  showUspBlock?: (data: unknown) => boolean
}

/** A generic match that may have our data/handle. */
export type UspMatch = UIMatch<UspData | unknown, UspHandle | unknown>

/** Decide if USP should show given all matched routes. */
export function computeUspVisibility(matches: UspMatch[]): boolean {
  for (const m of matches) {
    const handle = m.handle as UspHandle | undefined

    // 1) Dynamic handle wins if present and returns true
    if (typeof handle?.showUspBlock === 'function') {
      if (handle.showUspBlock(m.data)) return true
    }

    // 2) Static handle flag
    if (handle?.uspBlock === true) return true

    // 3) Fallback: the route simply returned data.uspBlock
    const data = m.data as UspData | undefined
    if (data?.uspBlock === true) return true
  }
  return false
}
